<template>
  <v-menu :close-on-content-click="false" v-model="menu" transition="slide-x-transition">
    <template v-slot:activator="{ on: menu }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            fab
            v-on="{ ...tooltip, ...menu }"
            class="elevation-3"
            x-small
            height="27"
            width="27"
            color="white"
            top
            right
            absolute
          >
            <v-icon color="grey darken-2">mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <span>Carrier Preferences</span>
      </v-tooltip>
    </template>
    <v-list class="py-0">
      <v-list-item class="pt-2" @click="dialog = true">
        <v-list-item-icon class="ml-1 mr-2"><v-icon>mdi-map-marker-outline</v-icon></v-list-item-icon>
        <v-list-item-title>Edit {{ $store.getters.locU }}s</v-list-item-title>
      </v-list-item>
      <v-divider></v-divider>
    </v-list>
    <v-radio-group class="white mt-0 pt-6 pl-5" v-model="operation">
      <v-radio color="billit"
        label="Duplicate Carrier"
        value="duplicateCarrier"
      ></v-radio>
      <v-radio color="billit"
        label="Clear All Choices"
        value="clearChoices"
      ></v-radio>
      <v-radio color="billit"
        label="Delete Carrier"
        value="deleteCarrier"
      ></v-radio>
    </v-radio-group>
    <v-layout column align-center class="white text-center px-4">
      <!-- <v-text-field v-model="accessCode" class="white"
        append-icon="mdi-lock-outline"
        type="password"
        outlined dense hide-details
        label="Verify Access Code"
      ></v-text-field> -->
      <v-btn
        class="my-3 mx-0 font-weight-medium" color="info"
        depressed :loading="loading" block
        @click="runOperation" height="30"
      >{{ operationName }}</v-btn>
      <p v-if="feedback" class="mt-1 red--text">{{ feedback }}</p>
    </v-layout>

    <v-dialog :persistent="locationsLoading" v-model="dialog" max-width="500">
      <v-card>
        <v-card-title>
          Edit Applicable {{ $store.getters.locU }}s
          <v-spacer />
          <v-icon aria-label="Close" @click="dialog = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="body-1 text-center">
          <v-form>
            <v-layout align-center justify-center wrap class="my-3">
              <v-scroll-x-transition>
                <v-select
                  multiple v-show="useLocations"
                  :items="$store.state.locations" :no-data-text="`No ${$store.getters.locL}s on record. Add one from the ${$store.getters.locU}s tab.`"
                  :disabled="allLocations" outlined v-model="locations"
                  :label="`Choose ${$store.getters.locU}s`"
                  item-text="name" item-value="id"
                >
                  <template v-slot:selection="{ item, index }">
                    <span style="width: 100%;" :class="{ 'caption': true, 'mt-3': index === 0 && locations.length > 1, 'mt-1': index > 0 && index < locations.length - 1 }"><v-icon color="billit darken-1">mdi-chevron-right</v-icon> {{ item.name }}</span>
                  </template>
                </v-select>
              </v-scroll-x-transition>
              <v-flex xs12 style="max-width: 416px;" class="mt-n10">
                <v-checkbox v-model="allLocations" :label="`All ${$store.getters.locU}s`" color="billit"></v-checkbox>
              </v-flex>            
            </v-layout>
            <!-- <v-text-field
              prepend-icon="mdi-lock-outline"
              type="password" class="mt-6"
              outlined dense v-model="locationsAccessCode"
              label="Verify Access Code"
            ></v-text-field> -->
          </v-form>
          <v-btn class="font-weight-medium" color="info" depressed
            default :loading="locationsLoading" rounded @click="saveLocations"
          >Save</v-btn>
          <p v-if="locationsFeedback" class="mt-5 red--text">{{ locationsFeedback }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-menu>
</template>

<script>
import { functions } from "@/firebase"

export default {
  props: ["carrier"],
  data() {
    return {
      name: "",
      menu: false,
      // locationsAccessCode: '',
      accessCode: '',
      operation: 'duplicateCarrier',
      // code: "",
      allLocations: false,
      locations: null, 
      feedback: '',
      locationsFeedback: '',
      locationsLoading: false,
      loading: false,
      dialog: false,
    }
  },
  created() {
    this.locations = this.carrier.locations
    this.allLocations = Array.isArray(this.locations)
    if (this.locations === 'all') { 
      this.locations = []
      this.allLocations = true
      // this.useLocations = false
    }
  },
  computed: {
    operationName() {
      let result = this.operation.replace( /([A-Z])/g, " $1" )
      return result.charAt(0).toUpperCase() + result.slice(1)
    },
    useLocations() {
      return !this.allLocations
    }
  },
  methods: {
    runOperation() {
      this.loading = true
      this.feedback = ''
      switch (this.operation) {
        case 'duplicateCarrier': this.duplicateCarrier()
          break
        case 'clearChoices': this.clearChoices()
          break
        case 'deleteCarrier': this.deleteCarrier()
          break
      }
    },
    saveLocations() {
      this.locationsFeedback = ''
      this.locationsLoading = true
      let f = functions.httpsCallable('updateCarrierLocations')
      // set to null if not being used
      f({ locations: this.useLocations ? this.locations : 'all', carrierId: this.carrier.id }).then(result => {
        setTimeout(() => {
          // this.locationsAccessCode = ''
          this.locations = this.carrier.locations
          this.allLocations = Array.isArray(this.locations)
          this.locationsLoading = false
          this.dialog = false
          this.menu = false
        }, 500)
      })
      .catch(error => {
        this.locationsFeedback = error.message
        this.locationsLoading = false
      })
    },
    duplicateCarrier() {
      let f = functions.httpsCallable('duplicateCarrier')
      f({ carrierId: this.carrier.id }).then(result => {
        // reset vars
        // this.accessCode = ''
        this.loading = false
        this.menu = false
      })
      .catch(error => {
        this.feedback = error.message
        this.loading = false
      })
    },
    clearChoices() {
      let f = functions.httpsCallable('clearChoices')
      f({ carrierId: this.carrier.id }).then(result => {
        // reset vars
        // this.accessCode = ''
        this.loading = false
        this.menu = false
      })
      .catch(error => {
        this.feedback = error.message
        this.loading = false
      })
    },
    deleteCarrier() {
      let f = functions.httpsCallable('deleteCarrier')
      f({ carrierId: this.carrier.id }).then(result => {
        // reset vars
        // this.accessCode = ''
        this.loading = false
        this.menu = false
      })
      .catch(error => {
        this.feedback = error.message
        this.loading = false
      })
    }
  }
}
</script>